const clamp = (value, min, max) => Math.max(min, Math.min(value, Math.max(min, max)));

// Use the measured coach size, including translated or longer copy. A target
// may be partly off screen while its page is settling into view.
export function walkthroughLayout(target, panel, viewport) {
  const margin = 12, gap = 16;
  const width = Math.min(panel.width || 400, viewport.width - margin * 2);
  const height = Math.min(panel.height || 320, viewport.height - margin * 2);
  const maxLeft = viewport.width - width - margin;
  const maxTop = viewport.height - height - margin;
  let left = (viewport.width - width) / 2, top = (viewport.height - height) / 2;
  if (viewport.width < 700) {
    left = margin; top = maxTop;
  } else if (target) {
    if (target.left + target.width + gap + width <= viewport.width - margin) {
      left = target.left + target.width + gap; top = target.top;
    } else if (target.left - gap - width >= margin) {
      left = target.left - gap - width; top = target.top;
    } else if (target.top + target.height + gap + height <= viewport.height - margin) {
      left = target.left; top = target.top + target.height + gap;
    } else if (target.top - gap - height >= margin) {
      left = target.left; top = target.top - gap - height;
    } else {
      left = maxLeft; top = maxTop;
    }
  }
  const placement = { left: clamp(left, margin, maxLeft), top: clamp(top, margin, maxTop), width, maxHeight: viewport.height - margin * 2 };
  if (!target) return { placement, spotlight: null };
  const x = clamp(target.left - 7, 8, viewport.width - 8);
  const y = clamp(target.top - 7, 8, viewport.height - 8);
  return { placement, spotlight: { left: x, top: y, width: Math.max(0, Math.min(viewport.width - 8, target.left + target.width + 7) - x), height: Math.max(0, Math.min(viewport.height - 8, target.top + target.height + 7) - y) } };
}
